import styled from "styled-components";

export const ImgContainer = styled.div`
  margin: 10px auto 15px;
  max-width: 150px;
  max-height: 150px;
  img {
    width: 100%;
    height: 100%;
  }
`;

export const NotReceived = styled.div`
  display: grid;
  gap: 5px;
  margin-bottom: 10px;

  & p {
    font-size: 12px;
    color: var(--white-100);
  }
  & strong {
    cursor: pointer;
    padding: 5px;
    color: var(--blue);
    font-size: 14px;

    :hover {
      color: var(--blue-300);
    }
  }
`;
